import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Braintree_customer } from '../../../models/accounting/banking/braintree_customer';
import { PaymentCustomerService } from '../../../providers/payment-customer.service';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';
import { faSave, faPhoneSquare, faAt, faUser } from '@fortawesome/pro-regular-svg-icons';

@Component({
  standalone: false,
  selector: 'app-braintree-add-customer',
  templateUrl: './braintree-add-customer.component.html',
styleUrls:  ['./braintree-add-customer.component.css']
})
export class BraintreeAddCustomerComponent extends SmsAbstractAppPage implements OnInit {
	faSave = faSave;
  faPhoneSquare = faPhoneSquare;
  faAt = faAt;
  faUser = faUser;
	customer: Braintree_customer = new Braintree_customer({});
	@Output() customer_created$: EventEmitter<Braintree_customer> = new EventEmitter<Braintree_customer>();

  constructor(private paymentCustomerService: PaymentCustomerService) {
  	super();
   }

  ngOnInit() {
  }

  onSubmit(){

  	if(this.customer.first_name == ''){
  		this.handleError("First name must have a value!");
  		return;
  	}
  	if(this.customer.last_name == ''){
  		this.handleError("Last name must have a value!");
  		return;
  	}
  	if(this.customer.email == ''){
  		this.handleError("Email must have a value!");
  		return;
  	}
  	if(this.customer.telephone == ''){
  		this.handleError("Telephone must have a value!");
  		return;
  	}

  	this.paymentCustomerService.create(this.customer).then(customer => {
  		this.customer_created$.emit(customer);
  	}).catch(error => {
  			this.handleError(error);
  		});

  }

}
